import { getCurrencySymbol } from "../../../utils/currencySymbols";
import { useState } from "react";

const ServiceCard = ({
  service,
  type,
  isSelected,
  currencyCode,
  onSelect,
  selectDisabled,
  t,
}) => {
  const [showImage, setShowImage] = useState(false);
  return (
    <div
      className={`card tab-card-item ${type}-card-item mb-3${
        isSelected ? " service-disabled" : ""
      }`}
      style={
        isSelected
          ? {
              background: "#e0e0e0",
              borderColor: "#bdbdbd",
              color: "#888",
            }
          : {}
      }
    >
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <button
          className={`btn ${isSelected ? "btn-secondary" : "btn-cancel"}`}
          onClick={() => !isSelected && onSelect && onSelect(service, type)}
          disabled={selectDisabled || isSelected}
        >
          {isSelected ? t("button_selected") : t("button_select")}
        </button>
      </div>
      <div className="item-text">
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <h3 style={{ margin: 0 }}>
            {service.serviceName || service.displayName || t("service")}
          </h3>
        </div>
        {service.serviceImagePath && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "0px",
              color: "#888",
              fontSize: "0.95em",
              marginTop: "2px",
            }}
          >
            <button
              type="button"
              className="info-icon-btn"
              onClick={() => setShowImage(true)}
              title="Show Media"
              style={{
                padding: 0,
                background: "none",
                border: "none",
                marginRight: "5px",
                color: "#888",
                display: "flex",
                alignItems: "center"
              }}
            >
              <i className="fa fa-circle-info"></i>
            </button>
           
            <span>See what this looks like</span>
          </div>
        )}
        {service.description && <p className="mb-0">{service.description}</p>}
        {showImage && service.serviceImagePath && (
          <div
            className="modal fade show"
            tabIndex="-1"
            role="dialog"
            style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
            onClick={() => setShowImage(false)}
          >
            <div
              className="modal-dialog modal-dialog-centered"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">{"Service Media"}</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowImage(false)}
                  ></button>
                </div>
                <div className="modal-body text-center">
                  {/\.(mp4|mov|avi|webm|mkv)$/i.test(
                    String(service.serviceImagePath),
                  ) ? (
                    <video
                      src={service.serviceImagePath}
                      controls
                      style={{ maxWidth: "100%", maxHeight: "400px" }}
                      className="rounded"
                    />
                  ) : (
                    <img
                      src={service.serviceImagePath}
                      alt="Service"
                      style={{ maxWidth: "100%", maxHeight: "400px" }}
                      className="img-thumbnail"
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="item-price">
        {service.price
          ? `${getCurrencySymbol(currencyCode)}${service.price.toFixed(2)}`
          : t("price_on_request")}
      </div>
    </div>
  );
};

export default ServiceCard;
